import { format, formatISO, parse, parseISO, startOfDay } from 'date-fns';
import { z } from 'zod4';

// Converts strings in the format yyyy-MM-dd to Date objects and back
export const isoDateToDate = z.codec(z.iso.date(), z.date(), {
	decode: (isoString) => parse(isoString, 'yyyy-MM-dd', startOfDay(new Date())),
	encode: (date) => format(date, 'yyyy-MM-dd'),
});

// Converts strings in the format yyyy-MM-ddTHH:mm:ssZ to Date objects and back
export const isoDatetimeToDate = z.codec(z.any(), z.date(), {
	decode: (isoString) => parseISO(isoString),
	encode: (date) => formatISO(date),
});
